module.exports = __webpack_public_path__ + "img/vi.5663535f.png";